export const VALID_VIEWS = ['login', 'home', 'basic-data', 'application-form'] as const;
export type ViewType = typeof VALID_VIEWS[number];